import { render } from "./ClientAccountPage.vue?vue&type=template&id=ce2898d6&scoped=true"
import script from "./ClientAccountPage.vue?vue&type=script&lang=js"
export * from "./ClientAccountPage.vue?vue&type=script&lang=js"

import "./ClientAccountPage.vue?vue&type=style&index=0&id=ce2898d6&lang=scss&scoped=true"
import "./ClientAccountPage.vue?vue&type=style&index=1&id=ce2898d6&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2898d6"]])

export default __exports__